var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"title":_vm.$t('add-service'),"size":"xl"},on:{"ok":_vm.okClicked}},[_c('service-picker',{attrs:{"services":_vm.services},model:{value:(_vm.form.serviceId),callback:function ($$v) {_vm.$set(_vm.form, "serviceId", $$v)},expression:"form.serviceId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }